// @flow

// State Configuration
export const TREE = 'userData'
export const BRANCH = 'users'
